import React from 'react';
import _ from 'lodash';

import PositionedGoodyHOC from '../PositionedGoodyHOC';
import { POSITIONED_GOODY_REFS } from '../../../../constants';

class Cat extends PositionedGoodyHOC {
	render() {
		return (
			<g>
				<circle ref={POSITIONED_GOODY_REFS.MARKER} cx="62.20683" cy="18.69299" />
				<g opacity="0.2">
					<path fill="#F2F2F2" d="M53.82021,17.4994c-23.60217,0-38.76643,6.58329-46.17512,12.91898
						c-1.64551,1.40723-0.95521-11.84636-0.40426-14.13902C9.43356,7.15493,16.89122,2.24953,30.03012,2.24953
						S53.82021,4.3605,53.82021,17.4994z" />
				</g>
				<g opacity="0.2">
					<path fill="#F2F2F2" d="M70.62128,17.4994c23.60217,0,38.76643,6.58329,46.17512,12.91898
						c1.64551,1.40723,0.95522-11.84636,0.40426-14.13902c-2.19273-9.12444-9.65038-14.02984-22.78929-14.02984
						S70.62128,4.3605,70.62128,17.4994z" />
				</g>
				<path fill="#FFEAAE" d="M124.44001,15.43018c0.00684-0.77832,0.0127-1.51367-0.50195-2.03271
					c-0.30176-0.30322-0.7207-0.45703-1.24805-0.45703h-4.18945C115.21882,4.35986,107.14314,0,94.41169,0
					c-0.08398,0-0.16699,0.00098-0.25098,0.00122V0H30.28083v0.00122C30.19684,0.00098,30.11383,0,30.02985,0
					C17.2984,0,9.22272,4.35986,5.94098,12.94043H1.75153c-0.52734,0-0.94629,0.15381-1.24805,0.45703
					c-0.51465,0.51904-0.50879,1.25439-0.50195,2.03271l0.00098,0.26025l-0.00098,0.26025
					c-0.00684,0.77832-0.0127,1.51367,0.50195,2.03271c0.30176,0.30322,0.7207,0.45703,1.24805,0.45703H4.5362
					c-1.10059,7.31421,0.52539,14.30518,4.62256,19.50244c4.08398,5.18262,10.19629,8.03662,17.21094,8.03662
					c18.2749,0,29.3125-13.99268,29.68262-27.76611l0.08398-0.15381c0.02051-0.03613,2.01562-3.59424,6.06934-3.59424
					c4.04981,0,6.02246,3.46191,6.1045,3.60938l0.0791,0.14258C68.7613,31.98926,79.7989,45.97949,98.07185,45.97949
					c7.01465,0,13.12695-2.854,17.21094-8.03662c4.09717-5.19727,5.72314-12.18823,4.62256-19.50244h2.78467
					c0.52734,0,0.94629-0.15381,1.24805-0.45703c0.51465-0.51904,0.50879-1.25439,0.50195-2.03271l-0.00098-0.26025L124.44001,15.43018
					z M9.42829,16.80518C11.3902,8.64014,18.32184,4.5,30.02985,4.5c13.64258,0,21.54004,2.12695,21.54004,12.99902
					c0,11.7876-9.42578,23.98047-25.2002,23.98047c-5.60645,0-10.46387-2.24512-13.67773-6.32178
					C8.95563,30.41553,7.7652,23.72607,9.42829,16.80518z M50.54303,4.5h23.35547c-2.29102,1.75293-3.98779,4.16748-4.86133,7.46558
					c-1.65527-1.22607-3.91455-2.27417-6.83155-2.27417c-2.91064,0-5.15869,1.03857-6.80615,2.25781
					C54.52497,8.65942,52.83014,6.25,50.54303,4.5z M94.41169,4.5c11.70801,0,18.63965,4.14014,20.60156,12.30518
					c1.66309,6.9209,0.47266,13.61035-3.26367,18.35254c-3.21387,4.07666-8.07129,6.32178-13.67773,6.32178
					c-15.77441,0-25.2002-12.19287-25.2002-23.98047C72.87165,6.62695,80.76911,4.5,94.41169,4.5z" />
			</g>
		);
	}
}

class Tortoise extends PositionedGoodyHOC {
	render() {
		return (
			<g>
				<circle ref={POSITIONED_GOODY_REFS.MARKER} cx="32.96962" cy="9.90729" />
				<g opacity="0.2">
					<path fill="#F2F2F2" d="M28.52471,9.27468c-12.50915,0-20.54621,3.48914-24.47281,6.84706
						c-0.87212,0.74583-0.50626-6.27857-0.21426-7.49368c1.16215-4.83595,5.1147-7.43581,12.07832-7.43581
						S28.52471,2.31106,28.52471,9.27468z" />
				</g>
				<g opacity="0.2">
					<path fill="#F2F2F2" d="M37.42928,9.27468c12.50915,0,20.54621,3.48914,24.47282,6.84706
						c0.87212,0.74583,0.50626-6.27857,0.21425-7.49368c-1.16214-4.83595-5.1147-7.43581-12.07832-7.43581
						S37.42928,2.31106,37.42928,9.27468z" />
				</g>
				<path fill="#FFEAAE" d="M65.9532,8.17799c0.00362-0.41251,0.00673-0.80225-0.26603-1.07734
					c-0.15993-0.16071-0.38197-0.24223-0.66147-0.24223h-2.22041C61.06597,2.31073,56.78586,0,50.03819,0
					c-0.04451,0-0.0885,0.00052-0.13301,0.00065V0H16.04884v0.00065C16.00433,0.00052,15.96033,0,15.91582,0
					C9.16815,0,4.88804,2.31073,3.14872,6.85843H0.92831c-0.27949,0-0.50153,0.08152-0.66146,0.24223
					c-0.27276,0.27509-0.26966,0.66483-0.26604,1.07734l0.00052,0.13793L0.00081,8.45386
					C-0.00281,8.86637-0.00592,9.25611,0.26685,9.5312c0.15993,0.16071,0.38197,0.24223,0.66146,0.24223h1.47587
					c-0.58331,3.87653,0.27846,7.58174,2.44996,10.33629c2.16451,2.74679,5.40403,4.25941,9.1218,4.25941
					c9.6857,0,15.53562-7.41612,15.73179-14.71604l0.04451-0.08152c0.01087-0.01915,1.06828-1.90495,3.21675-1.90495
					c2.1464,0,3.1919,1.83481,3.23538,1.91297l0.04192,0.07557c0.1972,7.29915,6.04713,14.71397,15.73179,14.71397
					c3.71776,0,6.95729-1.51262,9.1218-4.25941c2.1715-2.75455,3.03327-6.45976,2.44996-10.33629h1.47587
					c0.2795,0,0.50153-0.08152,0.66147-0.24223c0.27276-0.27509,0.26965-0.66483,0.26603-1.07734l-0.00052-0.13793L65.9532,8.17799z
					 M4.99699,8.90674C6.03681,4.57927,9.71058,2.385,15.91582,2.385c7.23057,0,11.41622,1.12729,11.41622,6.88948
					c0,6.24743-4.99566,12.70965-13.3561,12.70965c-2.97142,0-5.54585-1.18991-7.2492-3.35054
					C4.74648,16.12023,4.11556,12.57482,4.99699,8.90674z M26.78781,2.385h12.3784c-1.21424,0.92905-2.11353,2.20876-2.5765,3.95676
					c-0.8773-0.64982-2.07471-1.20531-3.62072-1.20531c-1.54264,0-2.73411,0.55044-3.60726,1.19664
					C28.89823,4.58949,27.99998,3.3125,26.78781,2.385z M50.03819,2.385c6.20525,0,9.87901,2.19427,10.91883,6.52174
					c0.88144,3.66808,0.25051,7.21349-1.72975,9.72685c-1.70335,2.16063-4.27778,3.35054-7.2492,3.35054
					c-8.36044,0-13.3561-6.46222-13.3561-12.70965C38.62197,3.51229,42.80763,2.385,50.03819,2.385z" />
			</g>
		);
	}
}

class Chicken extends PositionedGoodyHOC {
	render() {
		return (
			<g>
				<circle ref={POSITIONED_GOODY_REFS.MARKER} cx="43.54478" cy="13.08509" r="0" />
				<g opacity="0.2">
					<g>
						<path fill="#F2F2F2" d="M37.67415,12.24958c-16.52152,0-27.1365,4.6083-32.32259,9.04329
							c-1.15186,0.98506-0.66865-8.29245-0.28298-9.89731c1.53491-6.3871,6.75527-9.82089,15.9525-9.82089
							S37.67415,3.05235,37.67415,12.24958z" />
					</g>
				</g>
				<g opacity="0.2">
					<path fill="#F2F2F2" d="M49.43489,12.24958c16.52151,0,27.13651,4.6083,32.32259,9.04329
						c1.15186,0.98506,0.66865-8.29245,0.28298-9.89731c-1.53491-6.3871-6.75527-9.82089-15.95251-9.82089
						S49.43489,3.05235,49.43489,12.24958z" />
				</g>
				<path fill="#FFEAAE" d="M87.108,10.80112c0.00479-0.54482,0.00889-1.05957-0.35136-1.4229
					C86.54541,9.16597,86.25214,9.0583,85.883,9.0583h-2.93262C80.65317,3.0519,75.00019,0,66.08818,0
					c-0.05879,0-0.1169,0.00068-0.17568,0.00085V0H21.19658v0.00085C21.13779,0.00068,21.07969,0,21.0209,0
					C12.10888,0,6.45591,3.0519,4.15869,9.0583H1.22607c-0.36914,0-0.6624,0.10767-0.87363,0.31992
					c-0.36025,0.36333-0.35615,0.87808-0.35137,1.4229l0.00068,0.18218l-0.00068,0.18218
					c-0.00479,0.54482-0.00889,1.05957,0.35137,1.4229c0.21123,0.21226,0.50449,0.31992,0.87363,0.31992h1.94927
					c-0.77041,5.11995,0.36777,10.01362,3.23579,13.65171c2.85879,3.62783,7.1374,5.62564,12.04766,5.62564
					c12.79243,0,20.51875-9.79487,20.77783-19.43628l0.05879-0.10767c0.01435-0.02529,1.41094-2.51597,4.24854-2.51597
					c2.83487,0,4.21572,2.42334,4.27314,2.52656l0.05537,0.0998c0.26045,9.64038,7.98677,19.43355,20.77783,19.43355
					c4.91026,0,9.18887-1.9978,12.04765-5.62564c2.86802-3.63808,4.0062-8.53176,3.23579-13.65171H85.883
					c0.36914,0,0.66241-0.10767,0.87363-0.31992c0.36025-0.36333,0.35616-0.87808,0.35136-1.4229l-0.00068-0.18218L87.108,10.80112z
					 M6.5998,11.76362C7.97314,6.0481,12.82529,3.15,21.0209,3.15c9.5498,0,15.07803,1.48887,15.07803,9.09932
					c0,8.25132-6.59805,16.78633-17.64014,16.78633c-3.92451,0-7.32471-1.57158-9.57441-4.42524
					C6.26894,21.29087,5.43564,16.60825,6.5998,11.76362z M35.38012,3.15h16.34883c-1.60371,1.22705-2.79145,2.91724-3.40293,5.2259
					c-1.15869-0.85825-2.74018-1.59192-4.78208-1.59192c-2.03745,0-3.61108,0.727-4.76431,1.58047
					C38.16748,6.0616,36.9811,4.375,35.38012,3.15z M66.08818,3.15c8.1956,0,13.04775,2.8981,14.4211,8.61362
					c1.16415,4.84463,0.33086,9.52725-2.28458,12.84678c-2.2497,2.85366-5.6499,4.42524-9.57441,4.42524
					c-11.04209,0-17.64014-8.53501-17.64014-16.78633C51.01015,4.63887,56.53838,3.15,66.08818,3.15z" />
			</g>
		);
	}
}


function Aviators(props) {
	const glasses = {
		Cat,
		Tortoise,
		Chicken,
	};

	const ThisAviators = glasses[props.petType.name] || Cat;

	if (_.isUndefined(ThisAviators)) {
		return null;
	}

	return <ThisAviators {...props} />;
}

export default Aviators;



// WEBPACK FOOTER //
// ./src/components/Global/Goodies/Glasses/Aviators.js